// src/pages/sessions/components/LiveSession/VideoContainer.jsx
import React, { memo } from 'react';
import VideoGrid from './VideoGrid';

const VideoContainer = memo((props) => {
  // Simple pass-through wrapper
  return (
    <div className="absolute inset-0 bg-gray-900">
      <VideoGrid {...props} />
    </div>
  );
});

VideoContainer.displayName = 'VideoContainer';
export default VideoContainer;